
export const APPROVED = 'approved';
export const REJECTED = 'rejected';
export const GENERATED =  'generated';
export const EDITED =  'edited';
export const PENDING =  'pending';
export const UNCHANGED =  'unchanged';

export const MESSAGES = {
    dataFailed: 'Something went wrong! Please try later.',
    saved: 'Item successfully saved.',
    noChange: 'No changes found!',
    approved: 'Item successfully approved.',
    rejected: 'Item successfully rejected.',
    themeNotSelected: 'Approve Theme with Pending Summary',
    rejectedBulk: "You are about to reject the selected items. Confirm to Reject?",
    empty: "Item cannot be empty"
}